import type { UserSegmentIds } from '@iheartjane/data-access';

interface UseIsUserInSegment {
  enableCheck?: boolean;
  excludedIds?: UserSegmentIds | null;
  includedIds?: UserSegmentIds | null;
  userSegmentIds: number[];
}

export const useIsUserInSegment = ({
  enableCheck,
  excludedIds,
  includedIds,
  userSegmentIds,
}: UseIsUserInSegment) => {
  if (!enableCheck) return true;
  if (!excludedIds?.length && !includedIds?.length) return true;

  if (excludedIds && excludedIds.some((id) => userSegmentIds.includes(id))) {
    return false;
  }

  // Passed the exclusion check but there are no included ids
  if (!includedIds?.length) return true;

  return includedIds.some((id) => userSegmentIds.includes(id));
};
